import React, { FC } from 'react';
import {
  Icon,
  Tag,
  Icons,
  styled,
  IconProps as UIIconProps,
} from '@erecruit/ui-kit';
import { TagProps } from '@erecruit/ui-kit/src/atoms/Tag/Tag';

type CircleIconProps = {
  isFilled: boolean;
  isCanceled: boolean;
  isClosed: boolean;
};

type IconProps = {
  outerTagColor: TagProps['color'];
  outerTinyTagColor: TagProps['color'];
  tagColor: TagProps['color'];
  iconType: Icons;
  iconColor: UIIconProps['color'];
};

const OuterTag = styled(Tag)({
  margin: '-10px 0px',
  padding: 10,
});

const OuterTinyTag = styled(Tag)({
  margin: '-2px -2px',
  padding: 2,
});

const CircleIcon: FC<CircleIconProps> = props => {
  const { isCanceled, isClosed, isFilled } = props;
  let iconProps: IconProps;

  if (isFilled && !isCanceled && !isClosed) {
    iconProps = {
      outerTagColor: 'bgSuccess20',
      outerTinyTagColor: 'success',
      tagColor: 'bgWidgetPrimary',
      iconColor: 'success',
      iconType: 'filled-shift',
    };
  } else if (!isFilled && !isCanceled && !isClosed) {
    iconProps = {
      outerTagColor: 'bgPending20',
      outerTinyTagColor: 'pending',
      tagColor: 'bgWidgetPrimary',
      iconColor: 'pending',
      iconType: 'calendar',
    };
  } else if (isCanceled) {
    iconProps = {
      outerTagColor: 'bgCritical20',
      outerTinyTagColor: 'critical',
      tagColor: 'bgWidgetPrimary',
      iconColor: 'critical',
      iconType: 'cancelled-shift',
    };
  } else {
    iconProps = {
      outerTagColor: 'bgDisabled20',
      outerTinyTagColor: 'disabled',
      tagColor: 'bgWidgetPrimary',
      iconColor: 'disabled',
      iconType: 'cancelled-shift',
    };
  }

  return (
    <OuterTag circle color={iconProps.outerTagColor}>
      <OuterTinyTag circle color={iconProps.outerTinyTagColor}>
        <Tag circle color={iconProps.tagColor}>
          <Icon
            type={iconProps.iconType}
            color={iconProps.iconColor}
            size="large"
          />
        </Tag>
      </OuterTinyTag>
    </OuterTag>
  );
};

export default CircleIcon;
